module.exports = __webpack_public_path__ + "img/daizy_rail.35581ee9.jpg";